import * as types from '../constants/resolutiondetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  resolutiondetails: null,
  resolutiondetailsList: null,
  resolutionuserList: null
}

export function resolutionDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_RESOLUTION_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_RESOLUTION_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        resolutiondetails: action.data
      };
    case types.FETCH_RESOLUTION_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // resolutiondetailsList:action.error
      };
    case types.FETCH_RESOLUTION_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        resolutiondetailsList: null,
        resolutiondetails: null,
      };
    case types.FETCH_RESOLUTION_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_RESOLUTION_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        resolutiondetailsList: action.data
      };
    case types.FETCH_RESOLUTION_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
      case types.FETCH_RESOLUTION_USER_LIST_REQUEST:
        return {
          ...state,
          Status: true
        };
      case types.FETCH_RESOLUTION_USER_LIST_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiGetResult: true,
          resolutionuserList: action.data
        };
      case types.FETCH_RESOLUTION_USER_LIST_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiGetResult: false,
          // resolutiondetailsList:action.error
        };
    case types.ADD_RESOLUTION_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_RESOLUTION_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.ADD_RESOLUTION_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_RESOLUTION_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
      case types.UPDATE_FILE_REQUEST:
        return {
          ...initialState,
          Status: true
        };
      case types.UPDATE_FILE_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiPostResult: true
        };
      case types.UPDATE_FILE_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiPostResult: false
        };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/resolutiondetails.js